import React, { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import TitleFlip from '../../helpers/TitleFlip';

const SeoCopySection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$seoCopySection' });

  return (
    <section className="base-section seo-section">
      <div className="seo-copy">
        <h2 data-gsap="fade-up" data-gsap-delay="0.6" className="section-title">
          <TitleFlip normalText={t('yourConcierge')} flipList={['de']}>
            <span className="accent-bar">
              {t('comfort')}
              <em data-gsap="grow" data-gsap-delay="0.8" data-gsap-duration="0.8" />
            </span>
          </TitleFlip>
        </h2>
        <p data-gsap="fade-up" data-gsap-delay="0.65" className="section-txt">
          {t('bringComfort')}
        </p>
      </div>
    </section>
  );
};

export default SeoCopySection;
